
import Vue from 'vue'
import PartnerApplicationTable from '../components/partner-applications/PartnerApplicationTable.vue'

export default Vue.extend({
  components: { PartnerApplicationTable }
})
